module.exports = __webpack_public_path__ + "static/media/image-me.489f453e.jpeg";